import React from 'react';

import styles from './RadioButton.module.scss';

export interface RadioButtonPropsI {
  label?: string;
  group: string;
  checked?: boolean;
}

const RadioButton: React.FC<RadioButtonPropsI> = ({ label, group, checked }) => (
  <label
    className={styles.container}
    onClick={(e) => {
      // Clicking a <label> also triggers a synthetic click on the nested <input>.
      // When this component sits inside a clickable row, that results in the row
      // receiving two bubbled click events. Prevent the label's default activation.
      e.preventDefault();
    }}
  >
    {label}
    <input type="radio" {...{ checked }} name={group} readOnly />
    <span className={styles.checkmark}></span>
  </label>
);

export default RadioButton;
